import { ShieldCheck, Wallet, Clock4, ThumbsUp } from "lucide-react";

const items = [
    { icon: ShieldCheck, t: "Licensed & insured", s: "Colorado registered LLC" },
    { icon: Wallet, t: "Flat-rate pricing", s: "Quote before any work begins" },
    { icon: Clock4, t: "Same-day service", s: "Often booked & finished same day" },
    { icon: ThumbsUp, t: "Warranty on every job", s: "12 months / 12,000 miles" },
];

export default function TrustStrip() {
    return (
        <section
            data-testid="trust-strip"
            className="border-b hairline bg-white"
        >
            <div className="mx-auto max-w-[1400px] grid grid-cols-2 md:grid-cols-4">
                {items.map((it) => {
                    const Icon = it.icon;
                    return (
                        <div
                            key={it.t}
                            className="border-r last:border-r-0 hairline px-6 py-6 flex items-start gap-4"
                        >
                            <Icon
                                className="w-5 h-5 text-[#1d4ed8] mt-0.5 shrink-0"
                                strokeWidth={1.5}
                            />
                            <div>
                                <div className="font-display text-[14px] leading-tight">
                                    {it.t}
                                </div>
                                <div className="font-mono-tech text-[10px] text-[#52525b] mt-1.5 leading-snug">
                                    {it.s}
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </section>
    );
}
